import React from 'react';
import { Box, IconButton, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';

interface VideoPreviewBoxProps {
  url: string;
  index: number;
  onPreviewClose: (index: number) => void;
}

const VideoPreviewBox: React.FC<VideoPreviewBoxProps> = ({
  url,
  index,
  onPreviewClose
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: 'relative',
        width: { xs: '70px', lg: '120px' },
        height: { xs: '70px', lg: '120px' },
        marginTop: 5,
        marginBottom: 5,
        flexShrink: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.palette.background.paper
      }}
    >
      <video
        style={{
          position: 'absolute',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          filter: 'brightness(0.7)'
        }}
        src={url}
        muted
        loop
      />
      <PlayCircleIcon
        sx={{
          color: theme.palette.primary.contrastText,
          zIndex: 1
        }}
      />
      <IconButton
        edge="end"
        color="inherit"
        onClick={() => onPreviewClose(index)}
        aria-label={t('close')}
        sx={{
          position: 'absolute',
          right: 5,
          top: 0,
          color: theme.palette.primary.contrastText,
          zIndex: 2
        }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default VideoPreviewBox;
